import { render, staticRenderFns } from "./ClassroomView.vue?vue&type=template&id=5d34396f&scoped=true"
import script from "./ClassroomView.vue?vue&type=script&lang=js"
export * from "./ClassroomView.vue?vue&type=script&lang=js"
import style0 from "./ClassroomView.vue?vue&type=style&index=0&id=5d34396f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34396f",
  null
  
)

export default component.exports